"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tab = exports.TabElement = exports.TabPanel = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _temp, _class3, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _temp2, _class5, _descriptor16, _temp3;

var TabPanel = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(TabPanel, _Component);

  function TabPanel() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, TabPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(TabPanel)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "children", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "className", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "id", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "tabRootClassName", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "tabContentClassName", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "tabPaneClassName", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "activeClassName", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "tabPaneContentClassName", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "tabBarClassName", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      selectedTab: 0,
      children: _react.default.Children.toArray(_this.children)
    };
    _this.rootElement = null;
    _this.tabRootElement = null;
    _this.tabContentElement = null;
    _this.tabPaneElements = [];
    _this.tabBarElement = null;
    _this.t0 = null;
    _this.tid = null;
    _this.ignored = null;
    _this.finished = null;
    _this.ww = null;
    _this.wh = null;
    _this.d = null;
    _this.paused = null;
    _this.isPointer = false;
    return _this;
  }

  babelHelpers.createClass(TabPanel, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      this.tabPaneElements = this.tabPaneElements.filter(function (node) {
        return node.parentNode == _this2.tabContentElement;
      });
      this.tabPaneElements.sort(function (left, right) {
        return Number(left.dataset.tab) - Number(right.dataset.tab);
      });

      if (prevProps.children != this.children) {
        var ch = _react.default.Children.toArray(this.children);

        this.setState(function (_ref) {
          var selectedTab = _ref.selectedTab;
          return {
            selectedTab: Math.min(selectedTab, ch.length - 1),
            children: ch
          };
        });
      }

      if (prevState.selectedTab != this.state.selectedTab) {
        this.onShown(this.tabPaneElements.filter(function (tab) {
          return tab.dataset.tab == _this2.state.selectedTab;
        })[0], this.state.selectedTab);
      }
    }
  }, {
    key: "doSelectTab",
    value: function doSelectTab(event) {
      this.setState({
        selectedTab: Number(event.target.dataset.tab)
      });
    }
  }, {
    key: "gotRoot",
    value: function gotRoot(node) {
      this.rootElement = node;
    }
  }, {
    key: "gotTabRoot",
    value: function gotTabRoot(node) {
      this.tabRootElement = node;
    }
  }, {
    key: "gotTabContent",
    value: function gotTabContent(node) {
      this.tabContentElement = node;
    }
  }, {
    key: "gotTabPane",
    value: function gotTabPane(node) {
      if (node) this.tabPaneElements.push(node);
    }
  }, {
    key: "gotTabBar",
    value: function gotTabBar(node) {
      this.tabBarElement = node;
    }
  }, {
    key: "fix",
    value: function fix() {
      var _this3 = this;

      this.tabPaneElements.filter(function (tab) {
        return !_classList.default.has(tab, _this3.activeClassName);
      }).forEach(function (node) {
        node.tabIndex = -1;
        node.querySelectorAll('*:not([data-original-tab-index])').forEach(function (node) {
          node.dataset.originalTabIndex = node.hasAttribute('tabindex') ? node.tabIndex : '';
          node.tabIndex = -1;
        });
      });
      this.tabPaneElements.filter(function (tab) {
        return _classList.default.has(tab, _this3.activeClassName);
      }).forEach(function (node) {
        node.removeAttribute('tabindex');
        node.querySelectorAll('[data-original-tab-index]').forEach(function (node) {
          if (node.dataset.originalTabIndex) node.tabIndex = node.dataset.originalTabIndex;else node.removeAttribute('tabindex');
          delete node.dataset.originalTabIndex;
        });
      });

      if (this.tabPaneElements.filter(function (tab) {
        return _classList.default.has(tab, _this3.activeClassName);
      }).length == 1) {
        if (this.tabPaneElements.length == 1) {
          this.tabRootElement.style.transition = this.tabContentElement.style.transition = 'none';
          this.tabRootElement.style.height = this.tabContentElement.style.height = 'auto';
        } else {
          var EH = this.tabPaneElements.filter(function (tab) {
            return _classList.default.has(tab, _this3.activeClassName);
          }).reduce(function (acc, tab) {
            return acc.concat([].slice.call(tab.querySelectorAll(".".concat(_this3.tabPaneContentClassName))));
          }, []);

          var isVisible = function isVisible(node) {
            return node == document.body || window.getComputedStyle(node).display != 'none' && isVisible(node.parentNode);
          };

          EH = EH.filter(isVisible);
          var H = EH.map(function (v) {
            return v.getBoundingClientRect();
          });
          var tp = Math.min.apply(Math, babelHelpers.toConsumableArray(H.map(function (v) {
            return v.top;
          })));
          var bp = Math.max.apply(Math, babelHelpers.toConsumableArray(H.map(function (v) {
            return v.bottom;
          })));
          var height = bp - tp;
          this.tabRootElement.style.transition = 'height .3s ease';
          this.tabRootElement.style.height = "".concat(this.tabRootElement.offsetHeight, "px");
          setTimeout(function () {
            return _this3.tabRootElement.style.height = "".concat(height, "px");
          }, 0);
        }
      }
    }
  }, {
    key: "fixSoon",
    value: function fixSoon() {
      if (this.fixSoonTimeout) {
        clearTimeout(this.fixSoonTimeout);
      }

      this.fixSoonTimeout = setTimeout(this.fix, 64);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fix();
      window.addEventListener('resize', this.resized);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resized);
    }
  }, {
    key: "onShown",
    value: function onShown(target, index) {
      var position = this.tabPaneElements.indexOf(target),
          offset = (0 - position) * 100;
      this.tabContentElement.style.transform = "translate(".concat(offset, "%, 0)");
      setTimeout(this.fix, 0);
    }
  }, {
    key: "resized",
    value: function resized() {
      var _this4 = this;

      if (this.tabContentElement) {
        var activeTab = this.tabPaneElements.filter(function (tab) {
          return _this4.state.selectedTab == tab.dataset.tab;
        })[0];

        if (activeTab) {
          var EH = [].slice.call(activeTab.querySelectorAll(".".concat(this.tabPaneContentClassName)));
          var H = EH.map(function (v) {
            return v.getBoundingClientRect();
          });
          var tp = Math.min.apply(Math, babelHelpers.toConsumableArray(H.map(function (v) {
            return v.top;
          })));
          var bp = Math.max.apply(Math, babelHelpers.toConsumableArray(H.map(function (v) {
            return v.bottom;
          })));
          var height = bp - tp;
          this.tabContentElement.style.height = "".concat(height, "px");
        }
      }
    }
  }, {
    key: "tabPointerDown",
    value: function tabPointerDown(_ref2) {
      var clientX = _ref2.clientX,
          clientY = _ref2.clientY,
          pointerId = _ref2.pointerId,
          target = _ref2.currentTarget;

      if (this.paused || this.state.paused) {
        this.ignored = true;
        return;
      }

      if (this.t0) return;
      this.t0 = {
        clientX: clientX,
        clientY: clientY,
        pointerId: pointerId,
        mode: 'pointer'
      };
      this.ignored = null;
      this.beginTabMove(target);
    }
  }, {
    key: "tabMouseDown",
    value: function tabMouseDown(_ref3) {
      var clientX = _ref3.clientX,
          clientY = _ref3.clientY,
          target = _ref3.currentTarget;

      if (this.paused || this.state.paused) {
        this.ignored = true;
        return;
      }

      if (this.t0) {
        return;
      }

      this.t0 = {
        clientX: clientX,
        clientY: clientY,
        target: target,
        mode: 'mouse'
      };
      this.ignored = null;
      this.beginTabMove(target);
    }
  }, {
    key: "tabTouchStart",
    value: function tabTouchStart(_ref4) {
      var touches = _ref4.touches,
          target = _ref4.currentTarget;

      if (this.paused || this.state.paused) {
        this.ignored = true;
        return;
      }

      if (this.t0) {
        return;
      }

      var _touches$ = touches[0],
          clientX = _touches$.clientX,
          clientY = _touches$.clientY,
          identifier = _touches$.identifier;
      this.t0 = {
        clientX: clientX,
        clientY: clientY,
        identifier: identifier,
        mode: 'touch'
      };
      this.ignored = null;
      this.beginTabMove(target);
    }
  }, {
    key: "beginTabMove",
    value: function beginTabMove(target) {
      this.finished = false;
      this.wh = $(window).width();
      this.wh = $(window).height();
      this.ignored = null;
      Object.assign(target.style, {
        'user-select': 'none',
        '-moz-user-select': 'none',
        '-webkit-user-select': 'none',
        '-ms-user-select': 'none'
      });
    }
  }, {
    key: "tabMoveFilter",
    value: function tabMoveFilter(clientX, clientY) {
      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      for (var i in props) {
        if (this.t0[i] != props[i].value) return {
          ignored: props[i].ignored
        };
      }

      if (Math.abs(this.t0.clientY - clientY) > 0.05 * this.wh) {
        return {
          ignored: true
        };
      }

      if (Math.abs(this.t0.clientX - clientX) > 0.05 * this.wh) {
        return {
          clientX: clientX,
          clientY: clientY
        };
      }

      return {
        ignored: null
      };
    }
  }, {
    key: "tabPointerFilter",
    value: function tabPointerFilter(_ref5) {
      var pointerId = _ref5.pointerId,
          clientX = _ref5.clientX,
          clientY = _ref5.clientY;
      return this.tabMoveFilter(clientX, clientY, {
        type: {
          value: 'pointer',
          ignored: null
        },
        pointerId: {
          value: pointerId,
          ignored: true
        }
      });
    }
  }, {
    key: "tabMouseFilter",
    value: function tabMouseFilter(_ref6) {
      var clientX = _ref6.clientX,
          clientY = _ref6.clientY;
      return this.tabMoveFilter(clientX, clientY, {
        type: {
          value: 'mouse',
          ignored: null
        }
      });
    }
  }, {
    key: "tabTouchFilter",
    value: function tabTouchFilter(_ref7) {
      var touches = _ref7.touches;
      var _touches$2 = touches[0],
          identifier = _touches$2.identifier,
          clientX = _touches$2.clientX,
          clientY = _touches$2.clientY;
      return this.tabMoveFilter(clientX, clientY, {
        type: {
          value: 'touch',
          ignored: null
        },
        identifier: {
          value: identifier,
          ignored: true
        }
      });
    }
  }, {
    key: "tabMove",
    value: function tabMove(filter, event) {
      if (this.finished) return;
      var r;

      if (this.t0 && this.ignored === null) {
        var r = filter(event);

        if (r.ignored === true || r.ignored === false) {
          this.ignored = r.ignored;
        }

        if (r.ignored === true || r.ignored === null) return;
      }

      if (this.ignored === false) {
        var _r = r,
            clientX = _r.clientX,
            clientY = _r.clientY;

        if (Math.abs(clientX - this.t0.clientX) > 0.05 * this.ww) {
          this.d = clientX - this.t0.clientX;
        } else {
          this.d = 0;
        }

        this.tabContentElement.style.transform = "translate(".concat(0 - $(this.t0.clientX - clientX), "px, 0)");
      }
    }
  }, {
    key: "tabPointerMove",
    value: function tabPointerMove(event) {
      return this.tabMove(this.tabPointerFilter, event);
    }
  }, {
    key: "tabTouchMove",
    value: function tabTouchMove(event) {
      return this.tabMove(this.tabTouchFilter, event);
    }
  }, {
    key: "tabMouseMove",
    value: function tabMouseMove(event) {
      return this.tabMove(this.tabMouseMove, event);
    }
  }, {
    key: "tabMoveEnd",
    value: function tabMoveEnd(_ref8) {
      var _this5 = this;

      var type = _ref8.type,
          target = _ref8.currentTarget,
          pointerId = _ref8.pointerId;

      if (type == 'mouseout' && this.t0 && this.t0.mode == 'mouse') {
        if (target != this.t0.target) {
          return;
        }
      }

      if (type == 'pointerup') {
        target.releasePointerCapture(pointerId);
      }

      if (this.t0 && this.ignored === false) {
        var tgt = this.d < 0 ? -1 : 1;
        this.d = 0;
        var tgt = this.state.selectedTab + tgt;
        this.paused = true;
        this.root.style.transition = '.3s ease-in-out';
        setTimeout(function () {
          _this5.root.style.transition = '';
          setTimeout(function () {
            _this5.root.style.transition = '';
            _this5.paused = false;
            _this5.ignored = null;
            _this5.t0 = null;
            _this5.finished = null;
          }, 300);
        }, 0);

        if (tgt < this.state.children.length) {
          this.setState({
            selectedTab: tgt
          });
        }
      } else if (!this.paused) {
        this.ignored = this.t0 = this.finished = null;
      }

      Object.assign(target.style, {
        'user-select': '',
        '-moz-user-select': '',
        '-ms-user-select': '',
        '-webkit-user-select': ''
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      return _react.default.createElement("div", {
        className: this.className,
        id: this.id,
        ref: this.gotRoot
      }, this.state.children.length < 2 ? null : _react.default.createElement("header", {
        className: this.tabBarClassName
      }, _react.default.createElement("ul", {
        className: "nav nav-pills nav-small"
      }, this.state.children.map(function (node, index) {
        return _react.default.createElement("li", {
          key: index,
          className: index == _this6.state.selectedTab ? _this6.activeClassName : ''
        }, _react.default.createElement("a", {
          onClick: _this6.doSelectTab,
          "data-tab": index,
          href: "javascript:void(0)"
        }, node.props.title));
      }))), _react.default.createElement("div", {
        className: _classList.default.join('react', this.tabRootClassName),
        ref: this.gotTabRoot
      }, _react.default.createElement("div", {
        className: this.tabContentClassName,
        ref: this.gotTabContent,
        onTouchStart: this.tabTouchStart,
        onTouchMove: this.tabTouchMove,
        onTouchEnd: this.tabMoveEnd
      }, this.state.children.map(function (node, index) {
        return _react.default.createElement(TabElement, {
          passRef: _this6.gotTabPane,
          index: index,
          tabPaneClassName: _this6.tabPaneClassName,
          activeClassName: _this6.activeClassName,
          active: _this6.state.selectedTab == index,
          key: index,
          node: node
        });
      }))));
    }
  }]);
  return TabPanel;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "className", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'inner-content';
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'objectBody';
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabRootClassName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'objectBodyTabContent';
  }
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabContentClassName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'tab-content';
  }
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabPaneClassName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'tab-pane';
  }
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "activeClassName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'active';
  }
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabPaneContentClassName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'objectBodyTab';
  }
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabBarClassName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'objectBodyTabs';
  }
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "doSelectTab", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "doSelectTab"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotRoot", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotRoot"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotTabRoot", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotTabRoot"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotTabContent", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotTabContent"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotTabPane", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotTabPane"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotTabBar", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotTabBar"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "fix", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "fix"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "fixSoon", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "fixSoon"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "onShown", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "onShown"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "resized", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "resized"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabPointerDown", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabPointerDown"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabMouseDown", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabMouseDown"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabTouchStart", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabTouchStart"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "beginTabMove", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "beginTabMove"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabMoveFilter", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabMoveFilter"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabPointerFilter", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabPointerFilter"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabMouseFilter", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabMouseFilter"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabTouchFilter", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabTouchFilter"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabMove", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabMove"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabPointerMove", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabPointerMove"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabTouchMove", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabTouchMove"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabMouseMove", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabMouseMove"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabMoveEnd", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabMoveEnd"), _class.prototype)), _class);
exports.TabPanel = TabPanel;
var TabElement = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(TabElement, _Component2);

  function TabElement() {
    var _babelHelpers$getProt2;

    var _this7;

    babelHelpers.classCallCheck(this, TabElement);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this7 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(TabElement)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this7, "passRef", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    babelHelpers.initializerDefineProperty(_this7, "index", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    babelHelpers.initializerDefineProperty(_this7, "tabPaneClassName", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    babelHelpers.initializerDefineProperty(_this7, "activeClassName", _descriptor13, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    babelHelpers.initializerDefineProperty(_this7, "active", _descriptor14, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    babelHelpers.initializerDefineProperty(_this7, "node", _descriptor15, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    return _this7;
  }

  babelHelpers.createClass(TabElement, [{
    key: "render",
    value: function render() {
      if (this.node.props.customElement && this.__proto__ == TabElement.prototype) {
        return _react.default.createElement(require(this.node.props.customElement.type)[this.node.props.customElement.name || 'default'], this.props);
      }

      return _react.default.createElement("div", {
        ref: this.passRef,
        "data-tab": this.index,
        className: _classList.default.join(this.tabPaneClassName, this.active && this.activeClassName)
      }, this.getContent());
    }
  }, {
    key: "getContent",
    value: function getContent() {
      return this.node;
    }
  }]);
  return TabElement;
}(_react.Component), _temp2), (_descriptor10 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "passRef", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "index", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "tabPaneClassName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "activeClassName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "active", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
exports.TabElement = TabElement;
var Tab = (_class5 = (_temp3 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(Tab, _Component3);

  function Tab() {
    var _babelHelpers$getProt3;

    var _this8;

    babelHelpers.classCallCheck(this, Tab);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this8 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(Tab)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this8, "children", _descriptor16, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this8)));
    return _this8;
  }

  babelHelpers.createClass(Tab, [{
    key: "render",
    value: function render() {
      return _react.default.Children.only(this.children);
    }
  }]);
  return Tab;
}(_react.Component), _temp3), (_descriptor16 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class5);
exports.Tab = Tab;